/* global gtag */

import mockResponse from '../tests/objects/object';
import mobileMockResponse from '../tests/objects/mobileObject';

import { campaignIconsTapAction } from "@/modules/actions/campaignIconsTapAction";
import { icons, setupVideoIntersectionObserver } from "@/modules/parts/icons.js";
import apiRepositories from '@/plugins/apiRepositories'
import { trackStoreeelEvent } from "@/helpers/trackStoreeelEvent";
import { cvProcess } from "@/helpers/cvProcess";
import localStorageRepositories from "@/plugins/localStorageRepositories";
import { enableMouseDragScroll } from "@/modules/actions/mobile/enableMouseDragScroll";

export class reelLibrary {
  constructor(tagParams) {
    this.api = apiRepositories(tagParams)
    this.tagParams = tagParams
  }
  async exec() {
    // 動画情報を取得
    const urlParams = new URLSearchParams(window.location.search);
    const previewCampaignId = urlParams.get('_storeeel_preview_campaign_id');
    let items;
    // Playwrightテスト用: mockModeが 'mobile' または 'pc' に設定されている前提
    if (window.mockMode === 'mobile') {
      items = mobileMockResponse; // モバイル用
    } else if (window.mockMode === 'pc') {
      items = mockResponse; // PC用
    } else {
      // 通常API呼び出し
      items = await this.api.get('streams').index({ _storeeel_preview_campaign_id: previewCampaignId });
    }
    window.storeeelData = items.data;
    window.storeeelGtag = items.meta.gtag;
    window.isIphone = /iPhone/.test(navigator.userAgent) && !window.MSStream;

    // Google Analytics 読み込み（エラーをキャッチする）
    if (!window.gtag) {
      try {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.async = true;
          script.src = 'https://www.googletagmanager.com/gtag/js?id=' + items.meta.gtag;
          script.onload = () => {
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () {
              window.dataLayer.push(arguments);
            };
            gtag('js', new Date());
            gtag('config', items.meta.gtag);
            resolve();
          };
          script.onerror = (e) => {
            reject(e);
          };
          document.head.appendChild(script);
        });
      } catch (e) {
        console.warn('gtag.js の読み込みに失敗しました:', e);
      }
    }

    if (!window.mockMode) {
      // cv計測
      const cvCampaigns = await this.api.get('cvProcess').index()
      cvProcess(cvCampaigns.data)
    }

    try {
      // localStorageのTTLが切れているものは削除
      localStorageRepositories.get('campaignClick').removeExpiredCampaigns();
      localStorageRepositories.get('groupClick').removeExpiredCampaigns();
      localStorageRepositories.get('mediaView').removeExpired();
      localStorageRepositories.get('ctaClick').removeExpired();
    } catch (e) {
      console.warn('localStorageのTTL削除に失敗:', e);
    }

    items.data.forEach((item) => {
      // キャンペーンの表示回数をカウント
      // 確認時にエラーが出るので一旦調整しました。
      trackStoreeelEvent('storeeel_campaign_view', {
        'storeeel_name': item.name,
        'campaign_id': item.id,
      });
      const createHtmlContent = () => {
        const div = document.createElement('div');
        if (!item.isMobile) {
          // PCのみ中央寄せ
          div.style.justifyContent = 'center';
          div.style.display = 'flex';
        }
        const reelBase = document.createElement('div');
        reelBase.className = `storeeell_base_${item.id}`;
        reelBase.innerHTML = icons(item);

        enableMouseDragScroll(reelBase);

        const style = document.createElement('style');
        style.textContent = `
          .storeeell_base_${item.id} {
            display: flex;
            align-items: center;
            justify-content: left;
            overflow-x: auto;
            white-space: nowrap;
            padding: ${item.topPadding}px ${item.rightPadding}px ${item.bottomPadding}px ${item.leftPadding}px;
            margin: ${item.topMargin}px ${item.rightMargin}px ${item.bottomMargin}px ${item.leftMargin}px;
          }
          .storeeell_base_${item.id}::-webkit-scrollbar {
            display: none;
          }
        `;

        div.appendChild(reelBase);
        div.appendChild(style);
        return div;
      };

      // 動画を挿入する要素を取得
      let siteTitle = null;
      if (item.insertElementKind == "id") {
        siteTitle = document.querySelector(`#${item.insertElementValue}`);
      } else if (item.insertElementKind == "class") {
        const elements = document.getElementsByClassName(item.insertElementValue);
        siteTitle = elements[item.insertElementIndex];
      }
      // 動画を挿入(位置指定)
      const htmlElement = createHtmlContent();
      switch (item.position) {
        case "inner_start":
          siteTitle.insertBefore(htmlElement, siteTitle.firstChild);
          break;
        case "inner_end":
          siteTitle.appendChild(htmlElement);
          break;
        case "outer_before":
          siteTitle.parentNode.insertBefore(htmlElement, siteTitle);
          break;
        case "outer_after":
          siteTitle.parentNode.insertBefore(htmlElement, siteTitle.nextSibling);
          break;
      }
    });

    setupVideoIntersectionObserver();
    campaignIconsTapAction();
  }
}


window.StoreeelLibrary = reelLibrary
